import { getGlobalFeatureFlags } from '../runtimeConfig/runtimeConfig'

export const flagsFromConfig = () => {
  const globalFeatureFlags = getGlobalFeatureFlags()

  if (globalFeatureFlags) {
    return globalFeatureFlags.split(',').map((x: string) => [x, true] as [string, boolean])
  }
  return []
}

// Resolved per call rather than captured at module scope: this module is evaluated as part
// of the package's import graph, which completes before the host application injects its
// runtime configuration.
export const getConfigFlags = (): Map<string, boolean> => new Map(flagsFromConfig())
